import { render, staticRenderFns } from "./AddressRoundContainer.vue?vue&type=template&id=79ecf35d&"
import script from "./AddressRoundContainer.vue?vue&type=script&lang=js&"
export * from "./AddressRoundContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports